module.exports = __webpack_public_path__ + "img/Grybniak.33ef8933.jpeg";